<template>
    <el-dialog title="身份证信息" :visible.sync="dialogVisible" width="400px">
        <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-position="left">
            <el-form-item label="身份证人像页" prop="idCardFrontPath">
                <up-img :file.sync="form.idCardFrontPath" width="200" height="135"></up-img>
            </el-form-item>
            <el-form-item label="身份证国徽页" prop="idCardBackPath">
                <up-img :file.sync="form.idCardBackPath" width="200" height="135"></up-img>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入姓名" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="form.idCard" placeholder="请输入身份证号" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="证件有效期至" prop="idCardValid">
                <el-radio-group v-model="form.idCardValid">
                    <el-radio :label="1">短期有效</el-radio>
                    <el-radio :label="4102329600">长期有效</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="idCardValidInput" v-if="form.idCardValid != 4102329600">
                <el-date-picker v-model="form.idCardValidInput"
                    type="date" placeholder="选择日期" :picker-options="pickerOptions1">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitForm" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        // 身份证号验证规则
        const validateIdCard = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入身份证号'))
            } else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                callback(new Error('请输入正确的身份证号'))
            } else {
                callback()
            }
        }
        return {
            dialogVisible: false,
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() < new Date('1949-10-01 00:00:00') || time.getTime() > new Date('2099-12-31 00:00:00');
                },
            },
            form: {
                idCardFrontPath: '',
                idCardBackPath: '',
                name: '',
                idCard: '',
                idCardValid: '',
                idCardValidInput: ''
            },
            rules: {
                idCardFrontPath: [
                    { required: true, message: '请上传身份证人像面', trigger: 'change' }
                ],
                idCardBackPath: [
                    { required: true, message: '请上传身份证国徽面', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '请输入姓名' }
                ],
                idCard: [
                    { required: true, validator: validateIdCard, trigger: 'blur' }
                ],
                idCardValid: [
                    { required: true, message: '请选择证件有效期', trigger: 'change' }
                ],
                idCardValidInput: [
                    { required: true, message: '请选择证件有效期', trigger: 'change' }
                ]
            }
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.initForm();
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        },
        "form.idCard": {
            async handler(val, oldVal) {
                if (!val) {
                    return;
                }
                this.form.gender = this.$utils.getGender(val) == "男" ? 1 : 2;
            },
            deep: true,
        },
    },
    methods: {
        initForm() {
            const isLongTerm = this.info.idCardValid == '4102329600';
            let idCardValidInput = this.$utils.timeFn(this.info.idCardValid * 1000, "YYYY-MM-DD") == "-" ? "" : this.$utils.timeFn(this.info.idCardValid * 1000, "YYYY-MM-DD")
            this.form = {
                idCardFrontPath: this.info.idCardFrontPath || '',
                idCardBackPath: this.info.idCardBackPath || '',
                name: this.info.name || '',
                idCard: this.info.idCard || '',
                gender: this.info.gender,
                idCardValid: isLongTerm ? 4102329600 : 1,
                idCardValidInput: isLongTerm ? '' : idCardValidInput
            };
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.form);
                }
            });
        }
    }
}
</script>
